import React from 'react';
import {Box, Button, Card, CardContent, Grid2, Stack, Typography} from "@mui/material";
import palette from "../../../../../theme/palette";
import Papa from "papaparse";
import {toast} from "react-toastify";
import {Dropzone} from "../../../../../components/dropzone";
import {LoadingButton} from "@mui/lab";

interface Props {
    handleNext:()=>void;
    selectedFile:File|undefined;
    addressesToImport:string[];
    setAddressesToImport:(addresses:string[])=>void;
    isLoading:boolean;
    setIsLoading:(flag:boolean)=>void;
    setSelectedFile:(file:File|undefined)=>void;
    setFile64:(file:string|null)=>void;
    file64:string | null;
}

export const CsvUpload: React.FC<Props> = ({handleNext,
                                               selectedFile,
                                               setSelectedFile,
                                               file64,
                                               setFile64,
                                               addressesToImport,
                                               setAddressesToImport,
                                               isLoading,
    setIsLoading
                                           }) => {

    const sampleAddress = '\"60-07 138th St, Flushing, NY 11355, USA\"'

    const parseCSV = (file: File) => {
        Papa.parse(file, {
            header: false, // No headers in the CSV
            delimiter: "\n", // Treat each line as a single row
            skipEmptyLines: true, // Skip any empty lines
            complete: (result: any) => {
                const data = result.data as string[];
                if (data.length === 0) {
                    toast(
                        'Error: No addresses found in the file',
                        {
                            autoClose: 5000,
                            type: 'error',
                        }
                    );
                }else if(data.length > 0){
                    setAddressesToImport(data);
                }
                setIsLoading(false);
            },
            error: (error: any) => {
                toast(
                    'Error occurred while trying to import Addresses from the file, format is invalid. Please download the csv template and follow the proper formatting.',
                    {
                        autoClose: 1500,
                        type: 'error',
                    }
                );
                setIsLoading(false);
            },
        });
    };

    const onCancel = ()=>{
        setFile64(null);
        setSelectedFile(undefined);
        setAddressesToImport([]);
    }
    return (
        <Stack alignItems={'center'}>
            <Card>
                <CardContent sx={{padding:3}}>
                    <Stack>
                        <Typography fontWeight={500} fontSize={18} sx={{mb:2}}>
                            Import Address List
                        </Typography>
                        <Box sx={{mb:2}}>
                            <Typography fontWeight={400} fontSize={16} color={'text.secondary'}>
                                Upload an address list to generate your Bulk Safety Report.
                            </Typography>
                        </Box>
                        <Grid2
                            display={'flex'}
                            alignItems={'center'}
                            flexDirection={'row'}
                            spacing={3}
                        >
                            <Button
                                size="small"
                                variant="text"
                                sx={{ mt: 2 }}
                                onClick={() => {
                                    const element = document.createElement('a');
                                    const file = new Blob([sampleAddress], { type: 'text/csv' });
                                    const url = URL.createObjectURL(file);
                                    element.href = url;
                                    element.download = 'import-addresses-template.csv';
                                    document.body.appendChild(element);
                                    element.click();

                                    // Cleanup after download
                                    document.body.removeChild(element);
                                    URL.revokeObjectURL(url);
                                }}
                            >
                                Download csv template
                            </Button>
                        </Grid2>
                        <Box>
                            <Dropzone
                                file={file64 || undefined}
                                selectedFile={selectedFile}
                                onChange={(b64, file) => {
                                    setIsLoading(true)
                                    if (file.type !== 'text/csv') {
                                        toast(
                                            'Invalid file type, should be a .csv file.',
                                            {
                                                autoClose: 1500,
                                                type: 'error',
                                            }
                                        );
                                        setIsLoading(false);
                                        return;
                                    }
                                    setSelectedFile(file);
                                    setFile64(b64);
                                    parseCSV(file);
                                }}
                            />
                        </Box>
                        <Grid2
                            marginTop={20}
                            flexDirection={'row-reverse'}
                            container
                            spacing={2}
                            mt={3}
                        >
                            <LoadingButton sx={{color:palette.darkBlue}} onClick={handleNext} loading={isLoading} disabled={addressesToImport?.length === 0} autoFocus>
                                Confirm
                            </LoadingButton>
                            <Button disabled={false} color="inherit" onClick={onCancel}>
                                Cancel
                            </Button>
                        </Grid2>
                    </Stack>
                </CardContent>
            </Card>
        </Stack>
    )
}